import { Tooltip } from 'antd';
import { useContext, useRef } from 'react';

import { Button, OfferCard } from '@/components/Shared/ui';
import { ReloadOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';

import { OfferDetails } from '../../entities';
import { getOfferBodyProducts } from '../../helpers/offerBodyProduct';
import { OfferStepContext } from '../../offer-step';
import type { TBankOffers } from '../../types/bank-offer.types';
import useFormulateOfferItem from './hooks/useFormulateOfferItem';

interface IProps {
  bankOffer: TBankOffers;
}

const ForteDeclinedItem: React.FC<IProps> = ({
  bankOffer: initialBankOffer
}) => {
  const {
    userAccesses: {
      global: { isAdmin }
    }
  } = useAppSelector((state) => state.userInfo);

  const forteTimeout = useRef<NodeJS.Timeout | null>(null);

  const { handleChangeForteStatus, updateResponses } =
    useContext(OfferStepContext);

  const {
    additionalProducts,
    bankOffer,
    getDescription,
    headerIcon,
    headerTitle,
    isMobile,
    offerDetailsModal,
    setOfferDetailsModal
  } = useFormulateOfferItem({
    bankOffer: initialBankOffer
  });

  const onUpdateForteStatus = async () => {
    if (bankOffer?.extId !== null) {
      if (forteTimeout.current) clearTimeout(forteTimeout.current);
      const shouldUpdateResponses = await handleChangeForteStatus(
        bankOffer.extId
      );
      if (shouldUpdateResponses) updateResponses(true);
    }
  };

  const headerActions: React.ReactElement[] = [];
  if (bankOffer.extId !== null && isAdmin)
    headerActions.push(
      <Tooltip key={bankOffer.extId + 'status-button'} title="Обновить статус">
        <Button isSquare size="small" onClick={onUpdateForteStatus}>
          <ReloadOutlined className="forte-bank-item__icon" />
        </Button>
      </Tooltip>
    );

  return (
    <>
      <OfferCard
        className="bank-item"
        extId={bankOffer.extId || undefined}
        status="error"
        statusText={bankOffer.status.name}
      >
        <OfferCard.Header
          title={headerTitle}
          icon={headerIcon}
          status="error"
          requestBodyInfo={{
            bankName: bankOffer.bank.name,
            responsePrimaryBody: bankOffer.responsePrimaryBody,
            responseSendedBody: bankOffer.responseSendedBody
          }}
          descriptionAction={
            bankOffer.bankDescription
              ? {
                  onClick: () => setOfferDetailsModal(true),
                  text: <span className="offer-body__hidden">Описание</span>
                }
              : undefined
          }
          defaultMobileView={false}
          headerActions={headerActions}
        />

        {bankOffer.hasApprovedDate && (
          <>
            <OfferCard.Body
              footerActions={headerActions}
              additionalProducts={additionalProducts}
              products={getOfferBodyProducts({
                monthlyPayment: bankOffer.monthlyPayment,
                rate: bankOffer.rate,
                loanPeriod: bankOffer.loanPeriod,
                loanAmount: bankOffer.loanAmount,
                initialPayment: bankOffer.initialPayment,
                bankProduct: bankOffer.product,
                isMobile
              })}
            />
          </>
        )}
      </OfferCard>

      <OfferDetails
        bankCode={bankOffer.bank.name}
        bankResponse={{
          allResponse: getDescription()
        }}
        historyData={{
          bank: bankOffer.bank.name.replace(/_/g, ''),
          offerId: bankOffer.id
        }}
        isOpened={!!offerDetailsModal}
        onClose={setOfferDetailsModal}
      />
    </>
  );
};

export default ForteDeclinedItem;
